import { render, staticRenderFns } from "./genelparametreler.vue?vue&type=template&id=06c1adbe"
import script from "./genelparametreler.vue?vue&type=script&lang=js"
export * from "./genelparametreler.vue?vue&type=script&lang=js"
import style0 from "./genelparametreler.vue?vue&type=style&index=0&id=06c1adbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports